import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Колекції',
    href: '#collections'
  }, {
    name: 'Каталог',
    href: '#catalog'
  }, {
    name: 'Про нас',
    href: '#about'
  }, {
    name: 'Відгуки',
    href: '#reviews'
  }, {
    name: 'Контакти',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-brand-cream/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-239" data-mp="3bbzh8sbtohsq">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-240" data-mp="2wmfhckp5r44o">
        {/* Logo */}
        <a href="#" aria-label="na.lilu — головна" className="flex items-center -my-8" data-id="element-241" data-mp="2rnujut1aiyjx">
          <img src="https://cdn.magicpatterns.com/uploads/dtsy7m79ghQ5x7313MJovk/IMG_3734.png" alt="Логотип na.lilu" className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-28' : 'h-36'}`} data-id="element-242" data-mp="2hntw8uwe1w9x" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-243" data-mp="35l9ce6mubmg4">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-brand-dark/80 hover:text-brand-burgundy transition-colors" data-id="element-244" data-mp="30mzfnrlgwdse">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center" data-id="element-245" data-mp="1rdti6deuavct">
          <a href="tel:+380964797313" className="flex items-center gap-2 bg-brand-burgundy text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-brand-burgundy/90 transition-colors" data-id="element-246" data-mp="1recy5okxj9o7">
            <Phone className="w-4 h-4" data-id="element-247" data-mp="1mmuxz2qqdd4a" />
            Зв'язатися
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-brand-dark" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-248" data-mp="18mtx3nagu5ot">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-249" data-mp="ypxkb5djaxeg" /> : <Menu className="w-6 h-6" data-id="element-250" data-mp="yr8m4znf5v2x" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-251" data-mp="2t2x65g8icnu6">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-brand-cream border-t border-brand-beige overflow-hidden" data-id="element-252" data-mp="2t3gfi8k3e3wl">
            <div className="px-4 py-6 space-y-4 flex flex-col" data-id="element-253" data-mp="w60xdvrzm3rg">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-brand-dark block py-2" data-id="element-254" data-mp="rc6eguk7hstf">
                  {link.name}
                </a>)}
              <a href="tel:+380964797313" className="flex items-center justify-center gap-2 bg-brand-burgundy text-white px-6 py-3 rounded-full text-base font-medium mt-4" data-id="element-255" data-mp="1f198l1w11e4t">
                <Phone className="w-5 h-5" data-id="element-256" data-mp="3bvltsd882kra" />
                Зв'язатися
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}